import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  input: "",
  error: "",
};

const ingredientsInputSlice = createSlice({
  name: "ingredientsInput",
  initialState,
  reducers: {
    setIngredientInput: (state, action) => {
      state.input = action.payload;
    },
    setIngredientError: (state, action) => {
      state.error = action.payload;
    },
    clearIngredientInput: (state) => {
      state.input = "";
    },
  },
});

export const {
  setIngredientInput,
  setIngredientError,
  clearIngredientInput,
} = ingredientsInputSlice.actions;

export default ingredientsInputSlice.reducer;
